<template>
  <b-container>
    <Breadcrumbs crumbString="Products,Graphic Panels,ImageLOC Fused Graphics"></Breadcrumbs>
    <b-row class="image-slider-container">
      <b-col class="col-12 col-md-4 col-lg-4">
        <h2>{{ title }}</h2>
        <div>Digital-graphics, fused to aluminum</div><br>
        <div>ImageLOC fused graphics signs are produced by digitally printing full-color graphics to the surface of a
          1/8" thick aluminum substrate., The graphics are then fused to the aluminum. A UV protective coating is
          also applied. ImageLOC Fused Graphics signs have a nice, clean graphic appeal and carry a ten-year
          warranty in exterior conditions. They may be mounted in a frame or attached with studs affixed to the
          back of the sign.</div>
        <div><b-btn class="mt-3" @click="createEstimateFromPage">Create an Estimate</b-btn></div>
      </b-col>
      <b-col class="col-12 col-md-8 col-lg-8">
        <ImageSlider :images="images" class="image-slider"></ImageSlider>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  import Breadcrumbs from '@/components/Breadcrumbs.vue'
  import ImageSlider from '@/components/ImageSlider.vue'
  import { createEstimateFromPage } from '@/mixins/createEstimateFromPage'

  export default {
    components: {
      Breadcrumbs,
      ImageSlider
    },
    props: {
      images: {
        default: () => [
          require('@/assets/images/pages/imageLOC/imageLOC-fused-graphics01.jpg'),
          require('@/assets/images/pages/imageLOC/imageLOC-fused-graphics02.jpg'),
          require('@/assets/images/pages/imageLOC/imageLOC-fused-graphics03.jpg'),
          require('@/assets/images/pages/imageLOC/imageLOC-fused-graphics04.jpg'),
          require('@/assets/images/pages/imageLOC/imageLOC-fused-graphics05.jpg'),
          require('@/assets/images/pages/imageLOC/imageLOC-fused-graphics06.jpg'),
          require('@/assets/images/pages/imageLOC/imageLOC-fused-graphics07.jpg'),
          require('@/assets/images/pages/imageLOC/imageLOC-fused-graphics08.jpg'),
          require('@/assets/images/pages/imageLOC/imageLOC-fused-graphics09.jpg'),
          require('@/assets/images/pages/imageLOC/imageLOC-fused-graphics10.jpg'),
          require('@/assets/images/pages/imageLOC/imageLOC-fused-graphics11.jpg'),
          require('@/assets/images/pages/imageLOC/imageLOC-fused-graphics12.jpg'),
          require('@/assets/images/pages/imageLOC/imageLOC-fused-graphics13.jpg'),
          require('@/assets/images/pages/imageLOC/imageLOC-fused-graphics14.jpg')
        ],
        type: Array
      }
    },
    mixins: [ createEstimateFromPage ],
    data () {
      return {
        title: 'ImageLOC Fused Graphics'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/products/ImageLOC.vue